module.exports = __webpack_public_path__ + "img/banner8.e83c9b32.png";